export default {
    props: {
        color: {
            type: String,
            required: true,
        },
    },
}
